<template>
  <SelectWithSearch
    placeholder="Selecione um regime"
    label="Regime de Tributação"
    v-model="input"
    :clearable="clearable"
    :change="change"
    :options="taxRegimeCollection"
    :filterBy="descriptionFilter"
  >
    <template slot="options" slot-scope="props">
      <div class="selected">{{ formatOptions(props) }}</div>
    </template>
    <template slot="no-options"> Selecione um regime </template>
    <template slot="selected" slot-scope="props">
      <div class="selected">{{ formatOptions(props) }}</div>
    </template>
  </SelectWithSearch>
</template>

<script>
import SearchMixin from '@/core/mixins/SearchMixin';
import { SelectWithSearch } from '@/components/Form';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'SelectTaxRegime',
  components: {
    SelectWithSearch,
  },
  mixins: [SearchMixin],
  props: {
    clearable: {
      type: Boolean,
      default: true,
    },
    value: {},
  },
  data() {
    return {
      input: null,
    };
  },
  async mounted() {
    await this.setTaxRegimeCollection();
  },
  computed: {
    ...mapState('fiscalComponents', ['taxRegimeCollection']),
  },
  methods: {
    ...mapActions('fiscalComponents', ['setTaxRegimeCollection']),

    change(value) {
      this.$emit('input', value);
    },
    formatOptions(props) {
      return `${props.data.id} - ${props.data.description}`;
    },
  },
  watch: {
    value(current) {
      this.input = current;
    },
  },
};
</script>
